import _ from 'underscore'
import { popRootKeys, regexSearch } from '../util'
import Collection from './collection'
import Poll from './poll'
import activityFactory from '../activity_factory.js'

/*
 * polls collection
 * @namespace Model
 */
export default class Polls extends Collection {
  get url () { return '/api/polls' }

  /**
   * @param {Array|Backbone.Model} models Collection of models or just one.
   * @param {Object} options
   * @param {Backbone.Model} options.poll Parent activity with these subpolls.
   */
  initialize (models, options = {}) {
    this.poll = options.poll
  }

  model (attrs, options) {
    return activityFactory(attrs, options) || new Poll(attrs, options)
  }

  /*
   * Sort by position, then id to retain order from web app
   *
   * NOTE: Chrome's sorting becomes unstable when the length
   * of the collection is greater than 10. If this Collection
   * is used for new models that do not have a position
   * it will lead to unexpected behaviors.
   */
  comparator (m1, m2) {
    const m1Sequence = m1.get('position')
    const m2Sequence = m2.get('position')

    if (_.isUndefined(m1Sequence) || _.isUndefined(m2Sequence)) {
      return 0
    } else if (m1Sequence === m2Sequence) {
      return m1.id - m2.id
    } else {
      return m1Sequence - m2Sequence
    }
  }

  multipleChoicePolls () {
    const mcps = this.select(p => p.type() === 'multiple_choice_poll')

    return new Polls(mcps)
  }

  /*
   * Return the promise to the caller so they can call
   * .done and do whatever they need to do
   */
  query (query) {
    const data = { term: query }

    // Why is this route not a GET but rather a POST request?
    return this.sync('create', this, {
      url: '/my/polls/search',
      data,
      processData: true
    }).done(json => {
      return this.set(json.polls, { parse: true })
    })
  }

  getByPermalink (permalink) {
    return this.find(poll => poll.get('permalink') === permalink)
  }

  parse (json) {
    json = super.parse(...arguments)
    return popRootKeys(json)
  }

  search (term) {
    const regex = regexSearch(term)

    return this.filter(poll => regex.test(poll.get('title')))
  }

  static pollsToModels (polls) {
    polls.map(function (p) {
      if (p instanceof Poll) return p
      return activityFactory(p)
    })
  }
}
